import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { DatePickerOptionValues } from './types'

const DatePickerOptions = ({
  selectedOption = DatePickerOptionValues.All_time,
  onSelect,
}: {
  selectedOption?: string
  onSelect?: React.MouseEventHandler<HTMLElement>
}): JSX.Element => {
  const { _t } = useTypedTranslation()

  const optionKeys = Object.keys(DatePickerOptionValues) as (keyof typeof DatePickerOptionValues)[]

  const getActiveOption = (option: string) => (selectedOption === option ? 'datepicker-option-selected' : '')

  return (
    <>
      {optionKeys.map((option, idx) => (
        <Dropdown.Item
          className={`${getActiveOption(DatePickerOptionValues[option])}`}
          key={option}
          id={option}
          onClick={onSelect}
        >
          {_t(DatePickerOptionValues[option])}
        </Dropdown.Item>
      ))}
    </>
  )
}

export default DatePickerOptions
